var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmaiMnager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2261_1545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2261_1545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2261_1545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 512C114.841 512 0 397.159 0 256C0 114.841 114.841 0 256 0C397.159 0 512 114.841 512 256C512 397.159 397.159 512 256 512ZM388.758 345.931C390.276 345.929 391.731 345.325 392.804 344.252C393.877 343.179 394.481 341.724 394.483 340.206V179.489L264.233 282.921C261.823 284.836 258.91 285.793 255.999 285.793C253.088 285.793 250.176 284.835 247.765 282.921L117.516 179.489V340.206C117.518 341.724 118.122 343.179 119.195 344.252C120.268 345.325 121.723 345.929 123.241 345.931H388.758ZM368.798 166.069L256 255.644L143.201 166.069H368.798ZM420.966 171.794V340.208C420.966 357.967 406.517 372.416 388.758 372.416H123.241C105.481 372.416 91.034 357.967 91.034 340.208V171.794C91.034 154.035 105.482 139.587 123.241 139.587H388.758C406.517 139.586 420.966 154.035 420.966 171.794Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2261_1545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmaiMnager);
export default __webpack_public_path__ + "static/media/emai-mnager.157458f77a384a28d52402ace284594c.svg";
export { ForwardRef as ReactComponent };